import { RenderCellProps } from '@/components/cashflow/transactions/TableRow';
import { FlexCol, FlexRow } from '@/components/common/Flex';
import { Text } from '@/components/common/Typography';
import { toDollars } from '@/util/currency';
import { Box } from '@chakra-ui/react';

const AmountCell = ({ transactionEntry }: RenderCellProps) => {
    return (
        <FlexRow
            justify="flex-end"
            opacity={transactionEntry.isPending ? 0.5 : 1}
        >
            <FlexCol gap={1} align="flex-end" mt={1}>
                <Text whiteSpace="nowrap">
                    {toDollars(transactionEntry.amount, {
                        withCents: true,
                        alwaysSigned: true,
                    })}
                </Text>
                {transactionEntry.isPending && (
                    <Box
                        bg="gray.100"
                        color="gray.600"
                        fontSize="xs"
                        px={2}
                        mr={-1}
                        borderRadius={5}
                        w="62px"
                    >
                        PENDING
                    </Box>
                )}
            </FlexCol>
        </FlexRow>
    );
};

export default AmountCell;
